import { useEffect } from 'preact/hooks';

import AppLoader from '@/components/AppLoader';
import Redirect from '@/components/Redirect';
import { loadPage } from '@/helpers';

import { useDefaultLandingPath } from './hooks';

type DefaultLandingRedirectProps = {
  /**
   * Full document navigation instead of an in-SPA `route()`.
   * Required on the public bundle, where `/home` and `/highlights` are not registered routes.
   */
  fullPage?: boolean;
};

/**
 * Send `/` (and `/map`) to the viewport-aware default landing path — `/highlights` on mobile,
 * `/home` on desktop. Shared by the main and public entry points so both treat bare `/` the same.
 */
const DefaultLandingRedirect = ({ fullPage = false }: DefaultLandingRedirectProps) => {
  const defaultLandingPath = useDefaultLandingPath();

  useEffect(() => {
    if (fullPage) {
      loadPage(defaultLandingPath);
    }
  }, [fullPage, defaultLandingPath]);

  if (fullPage) {
    return <AppLoader />;
  }

  return <Redirect to={defaultLandingPath} />;
};

export default DefaultLandingRedirect;
